/*** IMPORTS FROM imports-loader ***/
var define = false;

// TODO: remove from `core-js@4`
var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

defineWellKnownSymbol('replaceAll');

